import { Sun, Moon, Building2, LucideIcon } from 'lucide-react'
import { storageService } from '@/services/storage-service'
import { themeService, Theme } from '@/services/theme-service'

export interface ThemePreset {
  backgroundImage: string
  iconColor: string
  textColor: string
}

/**
 * Legacy theme presets - kept for backwards compatibility
 * New code should use Theme objects from themeService
 */
export const THEME_PRESETS: Record<string, ThemePreset> = {
  light: {
    backgroundImage: storageService.getPublicUrl('login-background.png'),
    iconColor: '#ffaa3a',
    textColor: '#FFFFFF',
  },
  dark: {
    backgroundImage: storageService.getPublicUrl('login-background.png'),
    iconColor: '#ffaa3a',
    textColor: '#FFFFFF',
  },
}

export interface ThemeOption {
  value: string  // theme ID
  label: string  // display name
  icon: LucideIcon
}

/**
 * Get icon for a theme based on its name
 */
function getIconForTheme(themeName: string): LucideIcon {
  if (themeName.includes('dark')) return Moon
  if (themeName.includes('light')) return Sun
  if (themeName.includes('company')) return Building2
  return Sun
}

/**
 * Convert Theme objects from database to ThemeOption for UI
 */
export function convertThemesToOptions(themes: Theme[]): ThemeOption[] {
  return themes.map(theme => ({
    value: theme.id,  // Use theme ID as value
    label: theme.display_name,
    icon: getIconForTheme(theme.name),
  }))
}

/**
 * Load theme options for a specific user
 * Respects client-based access control
 */
export async function loadThemeOptionsForUser(userId: string): Promise<ThemeOption[]> {
  try {
    const themes = await themeService.getThemesForUser(userId)
    return convertThemesToOptions(themes)
  } catch (error) {
    console.error('Error loading theme options:', error)
    // Fallback to public themes only
    return [
      { value: 'light', label: 'Light', icon: Sun },
      { value: 'dark', label: 'Dark', icon: Moon },
    ]
  }
}
